import React from 'react'
import Flex from '../Flex'
import Icon from '../Icon'
import Text from '../Text'
import { BreadcrumbProps } from './Breadcrumb.types'
import { BreadcrumbWrapper } from './styled'

const Breadcrumb: React.FC<BreadcrumbProps> = ({
  separator = <Icon name='Right-outline' size={16} />,
  routes = [],
  onClick,
  ...props
}) => {
  return (
    <BreadcrumbWrapper {...props} columnGap='8px'>
      {routes.length > 0 &&
        routes.map((route, i) => {
          const isLast = i + 1 === routes.length

          return (
            <Flex
              key={`${route.path}-${i}`}
              alignItems='center'
              columnGap='8px'
              cursor={!isLast ? 'pointer' : 'text'}
              onClick={() => !isLast && onClick(route.path)}
            >
              <Text color={isLast ? 'black75' : 'blue50'}>{route.breadcrumbName}</Text>
              {!isLast && separator}
            </Flex>
          )
        })}
    </BreadcrumbWrapper>
  )
}

export default Breadcrumb
